import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const ArrowBackButton = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isRootRoute = location.pathname === "/";

    if (isRootRoute) return <Box></Box>;

    return (
        <IconButton
            onClick={() => {
                navigate(-1);
            }}
        >

            <ArrowBackIcon></ArrowBackIcon>
        </IconButton>
    );
};

export default ArrowBackButton;
